import { jsx } from 'react/jsx-runtime';
import { LayoutContainer } from '@zooplus/ui-components';
import styles from './LegalDisclaimer.module.scss.js';
import { useContext } from 'react';
import PageWidthContext from '../../contexts/PageWidthContext.js';

const LegalDisclaimer = ({ legalDisclaimer }) => {
    const pageWidth = useContext(PageWidthContext);
    return (jsx(LayoutContainer, { variant: pageWidth, children: jsx("div", { "data-zta": "footer-shipping-cost-modal-container", className: styles.disclaimerWrapper, children: jsx("div", { className: styles.disclaimer, children: jsx("div", { className: styles.disclaimerText, dangerouslySetInnerHTML: { __html: legalDisclaimer } }) }) }) }));
};

export { LegalDisclaimer as default };
//# sourceMappingURL=LegalDisclaimer.js.map
